import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate";
import SecureLS from "secure-ls";
var ls = new SecureLS({ encodingType: 'rc4', isCompression: false });

var setVuexKey = "jwt_template";

// console.log(window.setVuex);
Vue.use(Vuex)
export default new Vuex.Store({
    state: {
        currentUserToken: null,
        currentUser: null,
        isLoggedIn: false,
        isLoading: false,
        auth_error: null,
        hasAuthFactor: false,
        isAuthFactorPass: false,
        isConnected: true,
        disclaimerAlert: false,
    },
    getters: {
        isLoggedIn(state){
            return state.isLoggedIn;
        }
    },
    mutations: {
        login(state){
            state.isLoading = true;
            state.auth_error = null;
        },
        loginSuccess(state, payload){
            state.auth_error = null;
            state.isLoggedIn = true;
            state.isLoading = false;
            // state.userToken = payload.access_token;
            state.currentUserToken = payload.access_token;
            state.currentUser = payload.user;
            state.hasAuthFactor = payload.hasAuthFactor;
            state.isAuthFactorPass = payload.isAuthFactorPass;
            // state.currentUser = Object.assign({}, payload.user, {token: payload.access_token});
        },
        logout(state) {
            state.currentUserToken = null;
            state.isLoggedIn = false;
            state.currentUser = null;
            state.hasAuthFactor = false;
            state.isAuthFactorPass = false;
            state.disclaimerAlert = false;
        },
        refreshUserData(state, payload){
            state.currentUser = payload.user;
            // state.currentUserToken = payload.access_token;
            // state.currentUser = Object.assign({}, payload.user, {token: state.currentUser.token});
        },
        renewToken(state, payload){
            state.currentUserToken = payload;
        },
        twoFactorSuccess(state){
            state.isAuthFactorPass = true;
        },
        isConnected(state, payload){
            state.isConnected = payload;
        },
        isDisclaimerAlert(state){
            state.disclaimerAlert = true;
        }
    },
    actions: {
        logout(context) {
            context.commit("logout");
        },
    },

    plugins: [createPersistedState({
        key: setVuexKey,
        storage: {
            getItem: (key) => ls.get(key),
            setItem: (key, value) => ls.set(key, value),
            removeItem: (key) => ls.remove(key),
        },
    })],
});